import { Routes, Route, Navigate } from 'react-router-dom'
import { PinLogin } from './components/PinLogin'
import { ProtectedRoute } from './components/ProtectedRoute'
import { Dashboard } from './pages/Dashboard'
import { HealthCheck } from './pages/HealthCheck'
import { Cases } from './pages/Cases'
import { CaseDetail } from './pages/CaseDetail'
import { useAuthStore } from './stores/authStore'

function App() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)

  return (
    <Routes>
      {/* Health check - no auth required (for monitoring) */}
      <Route path="/health" element={<HealthCheck />} />
      
      <Route 
        path="/login" 
        element={isAuthenticated ? <Navigate to="/" replace /> : <PinLogin />} 
      />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/cases"
        element={
          <ProtectedRoute>
            <Cases />
          </ProtectedRoute>
        }
      />
      <Route
        path="/cases/:id"
        element={
          <ProtectedRoute>
            <CaseDetail />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default App
